<style lang="scss" scoped></style>

<template>
    <div class="order-confirmation">
        <slot></slot>
    </div>
</template>

<script>
import { required } from 'vee-validate/dist/rules';

export default {
    props: {
        order: {
            required: true,
        },
    },
    mounted() {
        this.$store.dispatch('clearBasket');

        const checkoutInfo = this.$cookies.get('checkout_info');

        if (checkoutInfo) {
            if (checkoutInfo.remark) {
                delete checkoutInfo.remark;
            }

            if (checkoutInfo.shipping_method) {
                delete checkoutInfo.shipping_method;
            }

            if (checkoutInfo.forklift_required) {
                delete checkoutInfo.forklift_required;
            }

            this.$cookies.set('checkout_info', checkoutInfo, '30d');
        }

        if (typeof dataLayer !== 'undefined' && dataLayer && this.getCookie(`indulineOrder:${this.order.id}`) !== 'complete') {

            let price = 0;
            this.order.order_products.forEach(element => {
                price += element.quantity * element.price;
            });
            let gaEvent = {
                event: 'indulineOrder',
                ecommerce: {
                    purchase: {
                        actionField: {
                            id: this.order.id,
                            affiliation: 'Online Store',
                            revenue: price,
                            tax: '',
                            shipping: this.shipping_costs,
                        },
                        products: this.order.order_products.map(product => {
                            return {
                                name: product.name,
                                id: product.product_id,
                                price: product.price,
                                quantity: product.quantity,
                                category: '',
                                brand: '',
                                variant: '',
                                coupon: '',
                            };
                        }),
                    },
                },
            };

            dataLayer.push({ ecommerce: null });
            dataLayer.push(gaEvent);

            this.setCookie(`indulineOrder:${this.order.id}`, 'complete');
        }
    },

    methods: {
        setCookie(name, value, days) {
            var expires = '';
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/';
        },
        getCookie(name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
    },
};
</script>
